import { Button, Input, Tooltip } from 'antd';
import { FC, useRef } from 'react';
import styled from 'styled-components';
import SvgIcon from '~src/shared/SvgIcon';

const InputStyled = styled(Input)`
  & .ant-input-group > .ant-input {
    cursor: pointer;
    height: 40px;
    border-color: ${({ theme }) => theme.black.a1};
    border: solid 1px ${({ theme }) => theme.black.a1};
  }
  & .ant-input:focus, .ant-input-focused {
    box-shadow: 0 18px 30px -11px rgba(78, 84, 107, 0.2);
    border: solid 1px ${({ theme }) => theme.baseBlue.a10};
  }
  & .ant-input-group-addon {
    border: solid 1px ${({ theme }) => theme.black.a1};

    &:hover {
      border: solid 1px ${({ theme }) => theme.baseBlue.a10};
    }
  }
`;

const ButtonStyled = styled(Button)`
  cursor: pointer;
  color: ${({ theme }) => theme.baseBlue.a10};
  border: none;
`;

interface Props {
  value: string;
}

const CopyableInput: FC<Props> = ({ value }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleInputClick = () => {
    if (inputRef.current) {
      inputRef.current.select();
    }
  };

  const handleCopy = () => {
    if (inputRef.current) {
      inputRef.current.select();
      document.execCommand('copy');
    }
  };

  return (
    <div>
      <InputStyled
        ref={inputRef}
        value={value}
        readOnly
        onClick={handleInputClick}
        addonAfter={
          <Tooltip title="Copy to clipboard">
            <ButtonStyled icon={<SvgIcon name={'iconCopyURL'} />} onClick={handleCopy} type="text"/>
          </Tooltip>
        }
      />
    </div>
  );
};

export default CopyableInput;
